import React__default from 'react';
import { useStytchIsAuthorized as useStytchIsAuthorized$1, useStytchSession as useStytchSession$1, useStytchUser as useStytchUser$1, withStytchPermissions as withStytchPermissions$1, withStytchSession as withStytchSession$1, withStytchUser as withStytchUser$1, StytchProvider as StytchProvider$1 } from './packages/web/src/ui/react/b2c/StytchContext.mjs';
export { useStytch, withStytch } from './packages/web/src/ui/react/b2c/StytchContext.mjs';

/**
 * Returns the active User.
 * The Stytch SDKs are used for client-side authentication and session management.
 * Check the isInitialized property to determine if the SDK has completed initialization.
 * Check the fromCache property to determine if the user data is from persistent storage.
 * @example
 * const {user, isInitialized, fromCache} = useStytchUser();
 * if (!isInitialized) {
 *     return <p>Loading...</p>;
 * }
 * return (<h1>Welcome, {user.name.first_name}</h1>);
 */ const useStytchUser = useStytchUser$1;
/**
 * Returns the active user's Stytch session.
 * The Stytch SDKs are used for client-side authentication and session management.
 * Check the isInitialized property to determine if the SDK has completed initialization.
 * Check the fromCache property to determine if the session data is from persistent storage.
 * @example
 * const {session, isInitialized, fromCache} = useStytchSession();
 * useEffect(() => {
 *   if (!isInitialized) {
 *     return;
 *   }
 *   if (!session) {
 *     router.replace('/login')
 *   }
 * }, [session, isInitialized]);
 */ const useStytchSession = useStytchSession$1;
const withStytchUser = withStytchUser$1;
const withStytchSession = withStytchSession$1;
const useStytchIsAuthorized = useStytchIsAuthorized$1;
const withStytchPermissions = withStytchPermissions$1;
/**
 * The Stytch Context Provider.
 * Wrap your application with this component in order to use Stytch everywhere in your app.
 * @example
 * const stytch = createStytchClient('public-token-<find yours in the stytch dashboard>')
 *
 * ReactDOM.render(
 *   <StytchProvider stytch={stytch}>
 *     <App />
 *   </StytchProvider>,
 *   document.getElementById('root'),
 * )
 */ const StytchProvider = ({ stytch, children, assumeHydrated = true })=>/*#__PURE__*/ React__default.createElement(StytchProvider$1, {
        stytch: stytch,
        assumeHydrated: assumeHydrated
    }, children);

export { StytchProvider, useStytchIsAuthorized, useStytchSession, useStytchUser, withStytchPermissions, withStytchSession, withStytchUser };
//# sourceMappingURL=StytchContext.mjs.map
